import React, { useEffect } from "react";
import { Button, Input } from "../../../../Components/StyledComponents";
import { languageInit, onTranslation, onlyNum } from "../../../../Utils/functions";
import './CreateOption.scss';
import axios from "axios";
import Select from 'react-select';
import { convertCost } from "../../../../Utils/functions";
import { support_language } from "../../../../Utils/services";
import { useSelector } from "react-redux";
import CheckLanguage from "../../../../Components/TableOrder/CheckLanguage";

const CreateOption = ({ createOption }) => {
    const [ name, setName ] = React.useState({})
    const [ price, setPrice ] = React.useState(0)
    const [ desc, setDesc ] = React.useState({})
    const [ posItem, setPosItem ] = React.useState('')
    const [ posMenuList, setPosMenuList ] = React.useState([]);
    const language = useSelector(state => state.tableorder.language);

    useEffect(()=>{
        getPosMenuList();
        setName({...languageInit()});
        setDesc({...languageInit()});
    },[]);

    const getPosMenuList = () => {
        axios.get('/api/table/order/pos/info/Menu')
        .then((data)=>{
            setPosMenuList(data.data.Menu.map(item => ({
                value: item.Code, 
                label:`${item.Code} | ${item.Name} | ${convertCost(item.Price)}원`, 
                item:{PosItem: item.Code, Name:item.Name, Price:item.Price}
            })))
        })
    };

    const selectMenu = (event) => {
        setPosItem(event.item.PosItem);
        setName({...name, ko: event.item.Name});
        setPrice(event.item.Price);
    };

    const post = () => {
        createOption({
            PosItem: posItem,
            Name : name,
            Description : desc
        })
    }
    const translationBtn = async () => {
        const trans_language = Object.entries(language).map(([key, value]) => value === true && key).filter(item => item !== false);
        const trans_data = [name.ko, desc.ko];
        const trans_value = ['name', 'desc'];
        const data = await onTranslation(trans_language, trans_data, trans_value);
        setName({...data.name});
        setDesc({...data.desc});
    };
    return (
        <div className="create-option">
            <div>
                <p className="label">옵션정보</p>
                <p className="label" style={{width:'100%', color:'#f95f53'}}>※ 테이블 오더에 보여지는 옵션 이름만 설정할 수 있습니다.</p>
                <p className="label" style={{width:'100%', color:'#f95f53'}}>※ 금액 변경을 원하실 경우 포스에서 옵션 정보를 변경해주세요.</p>
                <div className="row" style={{ marginTop : 16, marginBottom : 8 }}>
                    <Input value={posItem} disabled={true} placeholder="옵션코드" style={{ color:'#0F0F0F',  width : 80, paddingLeft: 8, paddingRight: 8 }}/>
                    <Input value={name.ko} onChange={(e) => setName({...name, ko: e.target.value})} placeholder="예) 1인분, 300g 등" style={{ width : 150, marginLeft: 16, marginRight: 16, paddingLeft:16, paddingRight:16 }}/>
                    <label htmlFor={`price`} data-domain="원">
                        <Input htmlFor={`price`} value={convertCost(price)} disabled={true} placeholder="0" style={{ color:'#0F0F0F', width : 100, paddingLeft:16, paddingRight:16 }}/>
                    </label>
                </div>
                <div style={{width:360}}>
                    <Select options={posMenuList} placeholder={'연동할 포스 메뉴를 선택해주세요'} onChange={event => selectMenu(event)} />
                    {/* <div className="row" style={{marginTop: 8, width:'100%'}}>
                        <Input value={desc} onChange={(e) => setDesc(e.target.value)} placeholder='옵션에 대한 설명을 입력해주세요.' style={{width:'100%'}}/>
                    </div> */}
                </div>
            </div>

            <CheckLanguage>
                <div className='btn-row' style={{margin:'16px 0', alignItems:'center'}}>
                    <p className='label' style={{flex:1, textAlign:'right', margin: 0, marginRight: 8, color:'#f95f53'}} >서비스 준비 중입니다.</p>
                    <Button variant="sub" small className='save-btn' fontSize={16} onClick={translationBtn} disabled={true || name.ko === '' || typeof name.ko === 'undefined'}>
                        자동번역
                    </Button>
                </div>
                <div style={{display:'flex', flexDirection:'column', gap: 4, marginTop:8}}>
                    {support_language.map((item, index) => 
                        language[item.value] && <div className="row">
                            <p className="label">{item.text}</p>
                            <Input value={name[item.value]} onChange={(e) => setName({...name, [item.value]: e.target.value})} placeholder="예) 1인분, 300g 등" style={{ width : 278, marginLeft: 16, marginRight: 16, paddingLeft:16, paddingRight:16 }}/>
                        </div>
                    )}
                </div>
            </CheckLanguage>
            <div className='btn-row'>
                <Button variant="main" className='save-btn' fontSize={16} disabled={typeof name.ko === 'undefined' || name.ko?.trim() === ''} onClick={() => post()}>
                    추가하기
                </Button>
            </div>
        </div>
    )
}

export default CreateOption;